import { ProductDetailsUI } from './ProductDetailsUI'
import { useProductDetails } from './useProductDetails'

export const ProductDetailsPage = () => {
  const props = useProductDetails()
  return <ProductDetailsUI {...props} />
}
